import { gql } from '@apollo/client'

export const GET_TESTIMONIALS = gql`
  query getTestimonials(
    $first: Int
    $language: String!
    $minimumRating: Int
    $minimumLength: Int
    $maximumLength: Int
    $after: String
  ) {
    testimonials(
      first: $first
      after: $after
      language: $language
      minimumRating: $minimumRating
      minimumLength: $minimumLength
      maximumLength: $maximumLength
    ) {
      edges {
        node {
          ... on Testimonial {
            id
            rating
            user {
              id
              avatar
              firstname
            }
            description
            createdAt
          }
        }
      }
      totalReviewCount
      reviewAverage
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
